import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { interesseFuerProdukteSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface InteresseFuerProdukte {
    nr: number;
    text: string;
}

export const defaultInteresseFuerProdukte: InteresseFuerProdukte = {
    nr: 0,
    text: '',
};

export function useInteresseFuerProdukteAsOptions(addEmpty = false): SelectOption[] {
    const interesseFuerProdukteList = useSelector(interesseFuerProdukteSelector);

    return React.useMemo<SelectOption[]>(() => {
        const list = interesseFuerProdukteList.map(
            (interesseFuerProdukte) =>
                ({ value: interesseFuerProdukte.nr.toString(), label: interesseFuerProdukte.text } as SelectOption),
        );
        if (addEmpty) {
            list.push({ value: '-1', label: '(kein Eintrag)' });
        }
        return list;
    }, [interesseFuerProdukteList, addEmpty]);
}

export async function addInteresseFuerProdukte(interesseFuerProdukte: InteresseFuerProdukte): Promise<void> {
    return callApi<void>(Controller.interesseFuerProdukte + '/add', { interesseFuerProdukte });
}

export async function updateInteresseFuerProdukte(interesseFuerProdukte: InteresseFuerProdukte): Promise<void> {
    return callApi<void>(Controller.interesseFuerProdukte + '/update', { interesseFuerProdukte });
}

export async function deleteInteresseFuerProdukte(interesseFuerProdukte: InteresseFuerProdukte): Promise<void> {
    return callApi<void>(Controller.interesseFuerProdukte + '/update', { interesseFuerProdukte });
}
